import React, { useContext, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ReactQuill, { Quill } from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import { useLocalization } from '@contexts/LocalizationContext'
import { Button, Col, DatePicker, Form, Input, Radio, Row, Select } from 'antd'

import {
  wellKidzClubButton,
  wellKidzClubECoupon,
  wellKidzClubError,
} from './List'
import UploadImage from '@components/UploadImage/UploadImageFromAntd'
import Text from '@components/Text'
import { ThemeContext } from '@contexts/ThemeContext'
const Size = Quill.import('formats/size')
Size.whitelist = ['nomal']
Quill.register(Size, true)
dayjs.extend(customParseFormat)
const FormComponent = ({
  handleSubmit,
  defaultValues = { typePermissionCouponLimit: 0 },
  doStatus,
}) => {
  const { t } = useLocalization()
  const { theme } = useContext(ThemeContext)
  const [form] = Form.useForm()
  const [isLimitCoupon, setIsLimitCoupon] = useState(false)
  const [isCheckConditionTh, setIsCheckConditionTh] = useState(false)
  const [isCheckConditionEn, setIsCheckConditionEn] = useState(false)

  const options = [
    { value: 'Food', label: 'อาหาร' },
    { value: 'Drink', label: 'เครื่องดื่ม' },
    { value: 'Service', label: 'บริการ' },
    { value: 'Medical', label: 'การแพทย์' },
    { value: 'Other', label: 'อื่นๆ' },
  ]
  const modules = {
    toolbar: [
      [{ size: Size.whitelist }],
      ['bold', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
    ],
  }
  const formats = ['size', 'bold', 'underline', 'list', 'bullet']

  /**
   * @type {{
   * footer: React.CSSProperties
   * body: React.CSSProperties
   * btnAdd: React.CSSProperties
   * radio: React.CSSProperties
   * inputForm: React.CSSProperties
   * reactQuill: React.CSSProperties
   * }}
   */
  const style = {
    btnAdd: {
      borderRadius: 8,
      width: '230px',
      height: '40px',
    },
    radioLimit: {
      paddingBottom: 12,
      width: 200,
    },
    radio: {
      width: 150,
    },
    inputForm: { width: '100%', height: '40px' },
    reactQuill: { maxHeight: 150, height: 150 },
  }

  useEffect(() => {
    form.resetFields()
    form.setFieldsValue(defaultValues)

    if (
      defaultValues.typePermissionCouponLimit >= 0 &&
      defaultValues.typePermissionCouponLimit !== null
    ) {
      setIsLimitCoupon(true)
    }
  }, [defaultValues])

  const radioHandle = (e) => {
    setIsLimitCoupon(e.target.value === 'Limit')
  }

  const handleChangeReactQuillTh = (content, _delta, _source, editor) => {
    const currentText = editor.getText()
    const length = currentText.trim().length
    form.setFieldsValue({ conditions: content })
    setIsCheckConditionTh(false)
    if (length === 0) {
      form.resetFields(['conditions'])
      setIsCheckConditionTh(true)
    }
    form.validateFields(['conditions'])
  }
  const handleChangeReactQuillEn = (content, _delta, _source, editor) => {
    const currentText = editor.getText()
    const length = currentText.trim().length
    form.setFieldsValue({ conditionsEng: content })
    setIsCheckConditionEn(false)
    if (length === 0) {
      form.resetFields(['conditionsEng'])
      setIsCheckConditionEn(true)
    }
    form.validateFields(['conditionsEng'])
  }

  return (
    <Form
      layout="vertical"
      form={form}
      name="control-hooks"
      onFinish={handleSubmit}
      onFinishFailed={(e) => {
        const errorCondition = e.errorFields.find((error) =>
          error.name.includes('conditions')
        )
        const errorConditionEng = e.errorFields.find((error) =>
          error.name.includes('conditionsEng')
        )
        if (errorCondition) setIsCheckConditionTh(true)
        if (errorConditionEng) setIsCheckConditionEn(true)
      }}
      requiredMark={false}
    >
      <div hidden>
        <Form.Item name="id">
          {/* ฝาก Id ไปกับ Form เนื่องจากเป็น modal ฝากไปกับ path ไม่ได้ */}
          <Input />
        </Form.Item>
      </div>
      <Row gutter={[15, 15]}>
        <Col span={12}>
          <Form.Item
            name="name"
            label={t(`${wellKidzClubECoupon}.eCouponNameThai`)}
            rules={[
              {
                required: true,
                message: `${t(`${wellKidzClubError}.pleaseEnter`)}${t(
                  `${wellKidzClubECoupon}.eCouponNameThai`
                )}`,
              },
            ]}
          >
            <Input style={style.inputForm} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="nameEng"
            label={t(`${wellKidzClubECoupon}.eCouponNameEnglish`)}
            rules={[
              {
                required: true,
                message: `${t(`${wellKidzClubError}.pleaseEnter`)}${t(
                  `${wellKidzClubECoupon}.eCouponNameEnglish`
                )}`,
              },
            ]}
          >
            <Input style={style.inputForm} />
          </Form.Item>
        </Col>
      </Row>
      {/* ======================================================= */}
      <Row gutter={[15, 15]}>
        <Col span={4}>
          <Form.Item
            name="image"
            label={t(`${wellKidzClubECoupon}.bannerImage`)}
            rules={[
              {
                required: true,
                message: `${t(`${wellKidzClubECoupon}.bannerImage`)}`,
              },
            ]}
          >
            <UploadImage
              defaultValueImg={defaultValues.image}
              styleImagePreview={{ height: '95%', borderRadius: 8 }}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="startAt"
            label={t(`${wellKidzClubECoupon}.startAt`)}
            rules={[
              {
                required: true,
                message: `${t(`${wellKidzClubError}.pleaseSelect`)}${t(
                  `${wellKidzClubECoupon}.startAt`
                )}`,
              },
            ]}
            style={{ marginBottom: 8 }}
          >
            <DatePicker style={{ ...style.inputForm, width: '100%' }} />
          </Form.Item>
          <Form.Item
            name="expiredAt"
            label={t(`${wellKidzClubECoupon}.expiredAt`)}
            rules={[
              {
                required: true,
                message: `${t(`${wellKidzClubError}.pleaseSelect`)}${t(
                  `${wellKidzClubECoupon}.expiredAt`
                )}`,
              },
            ]}
          >
            <DatePicker style={{ ...style.inputForm, width: '100%' }} />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="type"
            label={t(`${wellKidzClubECoupon}.eCouponType`)}
            rules={[
              {
                required: true,
                message: `${t(`${wellKidzClubError}.pleaseEnter`)}${t(
                  `${wellKidzClubECoupon}.eCouponType`
                )}`,
              },
            ]}
          >
            <Select
              size={'large'}
              options={options.map((item) => ({
                label: item.label,
                value: item.value,
              }))}
              style={style.inputForm}
              allowClear
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[15, 15]}>
        <Col span={12}>
          <div style={{ position: 'relative' }}>
            <Form.Item
              style={{ marginBottom: 4 }}
              name="typePermissionCoupon"
              label={t(`${wellKidzClubECoupon}.benefitType`)}
              rules={[
                {
                  required: true,
                  message: `${t(`${wellKidzClubError}.pleaseSelect`)}${t(
                    `${wellKidzClubECoupon}.benefitType`
                  )}`,
                },
              ]}
            >
              <Radio.Group onChange={radioHandle} style={{ width: '100%' }}>
                <Radio value={'UnLimit'} style={style.radioLimit}>
                  {t(`${wellKidzClubECoupon}.unlimited`)}
                </Radio>

                <Radio
                  value={'Limit'}
                  style={{ width: '100%' }}
                  className="radio_eCoupon"
                >
                  <div style={{ display: 'flex', gap: 10, width: '100%' }}>
                    <div style={{ width: 105 }}>
                      {t(`${wellKidzClubECoupon}.limited`)}
                    </div>
                    <Form.Item
                      style={{ width: '100%', marginBottom: 4 }}
                      name="typePermissionCouponLimit"
                      rules={[
                        {
                          required: isLimitCoupon,
                          message: ` `,
                        },
                      ]}
                    >
                      <Input
                        disabled={!isLimitCoupon}
                        placeholder={t(`${wellKidzClubECoupon}.specifyQuota`)}
                        style={{
                          ...style.inputForm,
                          width: '100%',
                          marginTop: -8,
                          marginBottom: 4,
                        }}
                      />
                    </Form.Item>
                  </div>
                </Radio>
              </Radio.Group>
            </Form.Item>
            {/* <div style={{ position: 'absolute', bottom: -25, right: 0 }}> */}
            {/* <Form.Item
              name="typePermissionCouponLimit"
              rules={[
                {
                  required: isLimitCoupon,
                  message: ` `,
                },
              ]}
            >
              <Input
                disabled={!isLimitCoupon}
                placeholder={t(`${wellKidzClubECoupon}.specifyQuota`)}
                style={{ ...style.inputForm, width: 270 }}
              />
            </Form.Item> */}
            {/* </div> */}
          </div>
        </Col>
        <Col span={6}>
          <Form.Item
            name="redemptionMethod"
            label={t(`${wellKidzClubECoupon}.usageType`)}
            rules={[
              {
                required: true,
                message: `${t(`${wellKidzClubError}.pleaseSelect`)}${t(
                  `${wellKidzClubECoupon}.usageType`
                )}`,
              },
            ]}
          >
            <Radio.Group>
              <Radio value={'TEXT_DISPLAY'} style={style.radio}>
                {t(`${wellKidzClubECoupon}.none`)}
              </Radio>
              <Radio value={'QTR'} style={style.radio}>
                {t(`${wellKidzClubECoupon}.numericCode`)}
              </Radio>
              <Radio value={'QR_CODE'} style={style.radio}>
                {t(`${wellKidzClubECoupon}.qrCode`)}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            name="limitInUse"
            label={t(`${wellKidzClubECoupon}.usageLimit`)}
            rules={[
              {
                required: true,
                message: `${t(`${wellKidzClubError}.pleaseSelect`)}${t(
                  `${wellKidzClubECoupon}.usageLimit`
                )}`,
              },
            ]}
          >
            <Radio.Group>
              <Radio value={'one_account'} style={style.radio}>
                {t(`${wellKidzClubECoupon}.oneTimePerAccount`)}
              </Radio>
              <Radio value={'one_month'} style={style.radio}>
                {t(`${wellKidzClubECoupon}.oneTimePerMonth`)}
              </Radio>
              <Radio value={'one_day'} style={style.radio}>
                {t(`${wellKidzClubECoupon}.oneTimePerDay`)}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={[15, 15]}>
        <Col span={12}>
          <Form.Item
            name="conditions"
            label={t(`${wellKidzClubECoupon}.activityDetailsThai`)}
            rules={[
              {
                required: true,
                validator: (_, value) => {
                  if (!value || isCheckConditionTh) {
                    return Promise.reject(
                      `${t(`${wellKidzClubError}.pleaseEnter`)}${t(
                        `${wellKidzClubECoupon}.activityDetailsThai`
                      )}`
                    )
                  }
                  return Promise.resolve()
                },
              },
            ]}
          >
            <ReactQuill
              className={`reactQuill editReactQuilleCoupon ${
                isCheckConditionTh ? 'ErrorReactQuill' : ''
              }`}
              theme="snow"
              onChange={handleChangeReactQuillTh}
              modules={modules}
              formats={formats}
              preserveWhitespace
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="conditionsEng"
            label={t(`${wellKidzClubECoupon}.activityDetailsEnglish`)}
            rules={[
              {
                required: true,
                validator: (_, value) => {
                  if (!value || isCheckConditionEn) {
                    return Promise.reject(
                      `${t(`${wellKidzClubError}.pleaseEnter`)}${t(
                        `${wellKidzClubECoupon}.activityDetailsEnglish`
                      )}`
                    )
                  }
                  return Promise.resolve()
                },
              },
            ]}
          >
            <ReactQuill
              className={`reactQuill editReactQuilleCoupon ${
                isCheckConditionEn ? 'ErrorReactQuill' : ''
              }`}
              theme="snow"
              onChange={handleChangeReactQuillEn}
              modules={modules}
              formats={formats}
              preserveWhitespace
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <div style={{ textAlign: 'center' }}>
          <Button
            type={'primary'}
            key={doStatus + 'ecoupon'}
            htmlType="submit"
            style={style.btnAdd}
          >
            <Text level={3} color={theme.text.white} strong>
              {doStatus === 'create'
                ? t(`${wellKidzClubButton}.addECoupon`)
                : t(`${wellKidzClubButton}.editECoupon`)}
            </Text>
          </Button>
        </div>
      </Form.Item>
    </Form>
  )
}
FormComponent.propTypes = {
  doStatus: PropTypes.string,
  handleSubmit: PropTypes.func,
  defaultValues: PropTypes.object,
}

export default FormComponent
